import gql from 'graphql-tag';

export const getFacilityContactLists = gql`
  query getFacilityContactLists($facilityId: String!) {
    getFacilityContactLists(facilityId: $facilityId) {
      ContactList {
        id
        name
      }
      ManagementContactList {
        id
        name
      }
      AdditionalResourceLists {
        id
        name
        AdditionalResourceListType {
          id
          name
        }
      }
    }
  }
`;
